export default {
    axis: {
        domain: {
            line: {
                stroke: '#777',
                strokeWidth: 1,
            },
        },
        ticks: {
            line: {
                stroke: '#777',
                strokeWidth: 1,
            },
            text: {
                fill: '#000',
                fontSize: 11,
            },
        },
        legend: {
            text: {
                fill: '#e25d47',
                fontSize: 11,
                fontWeight: 'bold',
            },
        },
    },
}
